import Patients from "../Patients";

export default function Reports() {
  return (
    <>
      <Patients heading={"Reports"} />
    </>
  );
}
